import directives from '../module';
import {Utils} from 'underscore-extensions';

class LandingPage {
    ytPlayerOptions: YT.PlayerOptions = {
        width: '560',
        height: '315',
        videoId: 'StEBsxh0I6s',
        playerVars: {
            showinfo: 0,
            enablejsapi: 1,
            playsinline: 1,
            modestbranding: 1,
            autoplay: 1,
            rel: 0
        },
        events: {
            onReady(e) {
                Utils.safe(() => e.target.mute());
            }
        }
    };

    private static readonly animationActiveClz = 'stager--active';

    readonly tabs = ['startup', 'teachers', 'animators', 'everyone'];

    tabChange() {
        const selectors               = '.tabs-animated-content, .quote-wrapper';
        const all: Array<HTMLElement> = [].slice.call(document.querySelectorAll(selectors));
        all.forEach(el => el.classList.remove(LandingPage.animationActiveClz));
        setTimeout(() => Utils.rAF(() =>
            all.forEach(el => el.classList.add(LandingPage.animationActiveClz)))
        );
    }
}

directives.component('landingPage', {
    controller: LandingPage,
    templateUrl: require('landing/landing-new.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/landing/LandingPage.ts